// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "569d21c",
    "hash": "569d21c",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "569d21c",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
